import clsx from 'clsx'
import { FC } from 'react'

import { ProjectSelect } from './components/project-select/project-select'
import { UserDropdown } from './components/user/user-dropdown'
import styles from './main.header.module.scss'
import { ProgressBar } from '../../../common/ui/progress-bar/progress-bar'
import { useRegisterStore } from '../../../entities/auth/stores/register.store'
import { STEPPER_CONFIG } from '../../auth/config/stepper-config'

interface MainHeaderProps {
  hasProgress: boolean
}

export const MainHeader: FC<MainHeaderProps> = ({ hasProgress }) => {
  const { step } = useRegisterStore()
  const maxStep = STEPPER_CONFIG.size

  const percent = Math.ceil((step * 100) / maxStep)

  return (
    <div
      className={clsx(
        {
          [styles.headerWithProgressBar]: hasProgress,
        },
        styles.header,
        'progress__container container-fluid d-flex gap-4 justify-content-between align-items-center text-white p-3',
      )}
    >
      {hasProgress ? (
        <>
          <ProgressBar percent={percent} />
          <div className="progress-step text-nowrap p-2 rounded-3">
            {step} Шаг из {maxStep}
          </div>
        </>
      ) : (
        <ProjectSelect />
      )}
      <UserDropdown hasMenu={!hasProgress} />
    </div>
  )
}
